import { IKeHoachThucTapUpdateTrangThaiRequest } from "../../../model/request/xet-thuc-tap/IKeHoachThucTapUpdateTrangThaiRequest";
import { IKeHoachThucTap } from "../../../model/response/xet-thuc-tap/IKeHoachThucTap";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachThucTapActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IKeHoachThucTap[],
    LOAD_ERROR: "",

    SAVE_START: {} as IKeHoachThucTap,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SHOW_EDIT_MODAL: {} as IKeHoachThucTap | undefined,
    CLOSE_EDIT_MODAL: undefined,

    UPDATE_ACTIVE_START: {} as IKeHoachThucTapUpdateTrangThaiRequest,
    UPDATE_ACTIVE_SUCCESS: undefined,
    UPDATE_ACTIVE_ERROR: "",
}

export const eKeHoachThucTapActionIds = generateActionTypeIds(eKeHoachThucTapActionsObj, "KE_HOACH_THUC_TAP");
export type IKeHoachThucTapActionTypes = IGenericActionType<typeof eKeHoachThucTapActionsObj, "KE_HOACH_THUC_TAP">;